<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner small variant="primary" type="grow" label="Spinning" />
        <b-spinner small variant="primary" type="grow" label="Spinning" />
        <b-spinner small variant="primary" type="grow" label="Spinning" />
      </div>
    </div>
    <div v-else>
      <div v-if="staffs != null && staffs.length === 0">
        <b-row class="align-center">
          <b-col><i>Aucune liste du personnel</i></b-col>
        </b-row>
      </div>
      <div v-else>
        <b-button v-b-toggle="'list-invisible-staff'" class="m-1" variant="info"
          >
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_staff')}}
          
          </b-button
        >
        <b-collapse id="list-invisible-staff">
          <b-row>
            <b-col>
              <b-form-group
                label="Filtrer"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                label-for="filterInput"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Taper pour rechercher un membre"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Effacer</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :fields="fields"
            :items="staffs"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            responsive="sm"
          >
            <template #cell(sest_is_delete)="row">
              <b-col v-if="row.item.sest_is_delete">
                <font-awesome-icon :icon="['fas', 'times']" class='deleted' />
              </b-col>
            </template>
            <template #cell(job_name)="row">
              <b-col :id="'job-' + row.item.staf_id"
                ><font-awesome-icon
                  :class="{
                    male: row.item.staf_is_male,
                    female: !row.item.staf_is_male,
                  }"
                  :icon="getIcon(row.item.jobs.job_identification)"
              /></b-col>
              <b-tooltip :target="'job-' + row.item.staf_id">{{
                row.item.job_name
              }}</b-tooltip>
            </template>
            <template #cell(name)="row">
              <b-col
                >{{ row.item.staf_lastname.toUpperCase() }}
                {{ row.item.staf_firstname }}</b-col
              >
            </template>
            <template #cell(mail)="row">
              <b-col>{{ row.item.staf_email }}</b-col>
            </template>
            <template #cell(sest_is_enable)="row">
              <b-badge
                :variant="row.item.sest_is_enable ? 'success' : 'danger'"
              >
                {{ row.item.sest_is_enable ? "Actif" : "Inactif" }}
              </b-badge>
            </template>
            <template #cell(sest_is_visible)="row">
               <font-awesome-icon :icon="viewInTabIcon(row.item.sest_is_visible)" :class="viewInTab(row.item.sest_is_visible)"/>
            </template>

            <template #cell(update)="row">
              <b-row>
                <b-col
                  ><b-button
                    v-b-modal="'modal-update-staff-' + row.item.staf_id"
                    size="sm"
                    variant="primary"
                    >Modifier</b-button
                  ></b-col
                >
                <b-modal
                  ref="modal_staff"
                  
                  :id="'modal-update-staff-' + row.item.staf_id"
                  title="Modifier un employé"
                  scrollable
                  hide-footer
                  :no-close-on-backdrop="true"
                >
                  <form-staff
                    :esta="id"
                    :id="row.item.staf_id"
                    @sendForm="receiveUpdate"
                    @sendCancel="receiveCancel"
                  />
                </b-modal>
                <b-col
                  ><b-button
                    v-b-modal="'modal-troubleshoot-' + row.item.staf_id"
                    size="sm"
                    variant="outline-warning"
                    >Dépanner</b-button
                  ></b-col
                >
                <modal-troubleshoot
                  :esta_id="id"
                  :full="false"
                  :target="'modal-troubleshoot-' + row.item.staf_id"
                  :id="row.item.staf_id"
                  :devices="devices"
                  :label="
                    row.item.staf_lastname + ' ' + row.item.staf_firstname
                  "
                  type="staf"
                />
              </b-row>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import FormStaff from "../forms/FormStaff.vue";
import ModalTroubleshoot from "../ModalTroubleshoot.vue";
import { getStaffsForEstablishment, updateStaff } from "../../services/staffs";

export default {
  name: "ListStaff",
  components: {
    FormStaff,
    ModalTroubleshoot,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    devices: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      title: "List Staff",
      cancellations: [],
      fields: [
        {
          sest_is_delete: {
            label: "Supprimé",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          job_name: {
            label: "Rôle",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          name: {
            label: "Nom",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          mail: {
            label: "E-mails",
            sortable: true,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          sest_is_enable: {
            label: "Actif",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          sest_is_visible: {
            label: "Listé sur Tablette",
            sortable: true,
            tdClass: "align-middle",
          },
        },        
        {
          update: {
            label: "Actions",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      filter: null,
      filterOn: [],
      loading: true,
      staffs: null,
    };
  },
  async mounted() {
    this.getstaffs();
    this.setLoaded();
  },
  methods: {
    hideEdit(){
      this.$refs['modal_staff'].hide();
    },
    receiveCancel() {
      this.hideEdit();
    },
    receiveUpdate(formStaff) {
      this.hideEdit();
      this.setStaff(formStaff);
      this.setLoaded();
    },
    setLoaded() {
      this.loading = false;
    },
    async getstaffs() {
      const data = await getStaffsForEstablishment(this.id);
      if(data) this.staffs = data;
    },
    async setStaff(staff){
      const value = await updateStaff(this.id, JSON.parse(staff));
      if (value) this.getstaffs();
    },
    getIcon(job) {
      const icons = ["fas"];
      switch (job) {
        case "job_doctor":
          icons.push("user-md");
          break;
        case "job_director":
          icons.push("user-tie");
          break;
        case "job_nurse":
        case "job_nursing_assistant":
        case "job_assistgeronto":
        case "job_assismedpsyco":
        case "job_nursecoord":
          icons.push("user-nurse");
          break;
        case "job_secretary":
        case "job_housekeeping":
          icons.push("user-cog");
          break;
        case "job_animator":
        case "job_civicservice":
          icons.push("users");
          break;
        case "job_physiotherapist":
        case "job_occuptherapist":
        case "job_psychomotherapist":
        case "job_psychologist":
        case "job_dietician":
        case "job_speechtherapist":
        case "job_dentist":
          icons.push("user-md");
          break;

        default:
          icons.push("question-circle");
      }
      return icons;
    },
    viewInTabIcon(visible){
      return ['fas', (visible ? 'eye': 'eye-slash' )];
    },    
    viewInTab(visible){
      return  (visible ? "viewtab_green" : "viewtab_red");
    }
  },
};
</script>
<style>
.deleted {
  font-size: 20px;
  color:rgb(92, 16, 16); 
}
.viewtab_green {
  font-size: 20px;
  color: rgb(25, 148, 14);
}
.viewtab_red {
  font-size: 20px;
  color: #dc3545;
}

.male {
  font-size: 20px;
  color: #17a2bf;
}
.female {
  font-size: 20px;
  color: hotpink;
}
.gosted {
  color: grey;
  background-color: lightgray;
}
</style>
